import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useProposeApplication } from '../../api/applications';

const MAX = 10 * 1024 * 1024;

export default function ProposeApplication() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const propose = useProposeApplication(jobId!);

  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [compensation, setCompensation] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);

  const submit = () => {
    setError(null);
    if (!email.trim()) return setError('Email is required (it identifies the candidate)');
    if (file && file.type !== 'application/pdf') return setError('CV must be a PDF');
    if (file && file.size > MAX) return setError('CV must be 10 MB or smaller');
    const form = new FormData();
    form.append('email', email.trim());
    if (fullName.trim()) form.append('fullName', fullName.trim());
    if (phone.trim()) form.append('phone', phone.trim());
    if (compensation.trim()) form.append('compensation', compensation.trim());
    if (file) form.append('cv', file);
    propose.mutate(form, { onSuccess: (app) => navigate(`/applications/${app.id}`) });
  };

  return (
    <div className="panel">
      <h2>Propose a candidate</h2>
      <p className="muted small">
        Enter the candidate's email. If they already exist in the talent pool, their latest CV is
        reused automatically (upload a new one to override). New candidates need a name and a CV.
      </p>
      <div className="form">
        {(error || propose.error) && (
          <div className="banner-error">{error || (propose.error instanceof Error ? propose.error.message : 'Failed')}</div>
        )}
        <label className="field"><span>Email (identity)</span>
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="jane@example.com" /></label>
        <div className="field-row">
          <label className="field"><span>Full name (required for new)</span>
            <input value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Jane Doe" /></label>
          <label className="field"><span>Phone</span>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+40 …" /></label>
        </div>
        <label className="field"><span>Compensation expectations (HR/Admin only)</span>
          <input value={compensation} onChange={(e) => setCompensation(e.target.value)} placeholder="€450/day or €65k" /></label>
        <label className="field"><span>CV (PDF, optional if candidate already has one)</span>
          <input type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files?.[0] ?? null)} />
          {file && <small className="muted">{file.name}</small>}</label>
        <div className="form-actions">
          <button className="btn-primary" onClick={submit} disabled={propose.isPending}>
            {propose.isPending ? 'Proposing…' : 'Propose candidate'}
          </button>
          <button className="btn-ghost" onClick={() => navigate(`/jobs/${jobId}`)} disabled={propose.isPending}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
